define("shared/utils/time-helpers/create-moment-in-tz", ["exports", "moment-timezone"], function (_exports, _momentTimezone) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"moment-timezone"eaimeta@70e063a35619d71f
  /**
   * Takes a unix timestamp and returns a
   * moment object in the local timezone
   *
   * @param unixTime the unix timestamp given
   * @param timeZone the timezone name
   *
   * @returns Moment object in local timezone
   */
  function createMomentInTz(unixTime, timeZone) {
    if (!unixTime) {
      return (0, _momentTimezone.default)().tz(timeZone);
    }
    return (0, _momentTimezone.default)(unixTime * 1000).tz(timeZone);
  }
  var _default = _exports.default = createMomentInTz;
});